import { render } from "./SettingsPrinterAddOrEdit.vue?vue&type=template&id=997e8c80"
import script from "./SettingsPrinterAddOrEdit.vue?vue&type=script&lang=js"
export * from "./SettingsPrinterAddOrEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__